module.exports = __webpack_public_path__ + "media/newstyle/images/icon-globe-afb803d83cca903cfe472e74552f1818.png";